import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { listQueryDefaults } from '../../../lib/query/listQuery';
import { getTaskItems } from '../api/tasks';
import type { GetTaskItemsParams, PagedResult, TaskItemListItem } from '../types';

export function useTaskItems(
  params: GetTaskItemsParams = {},
  options?: Pick<UseQueryOptions<PagedResult<TaskItemListItem>>, 'enabled'>,
) {
  return useQuery({
    queryKey: ['taskItems', params],
    queryFn: () => getTaskItems(params),
    ...listQueryDefaults,
    ...options,
  });
}
